// Internal modules
import { $logger } from '@/lib/logger';

const logWhenCheckingBnplEligibility = (isEligible = false) => {
  $logger.fpti('bnpl_eligiblity_check', {
    bnpl_eligible: isEligible ? 'Y' : 'N',
    state_name: 'bnpl_guest_eligibility',
    transition_name: 'bnpl_eligibility_check',
  });
};

const logWhenDisplayForcedSignupBNPL = () => {
  $logger.fpti('bnpl_display_forced_signup_link', {
    state_name: 'bnpl_signup',
    transition_name: 'prepare_pay_later',
  });
};

const logOnClickForcedSignupBNPL = () => {
  $logger.fpti('bnpl_click_optional_guest_link', {
    state_name: 'bnpl_signup',
    transition_name: 'process_pay_later',
  });
};

const logWhenDisplayOptionalGuestBNPL = () => {
  $logger.fpti(
    'bnpl_display_optional_guest_link',
    {
      state_name: 'bnpl_guest',
      transition_name: 'prepare_pay_later',
    },
    true,
  );
};

const logOnClickOptionalGuestBNPL = () => {
  $logger.fpti(
    'bnpl_click_optional_guest_link',
    {
      state_name: 'bnpl_guest',
      transition_name: 'process_pay_later',
    },
    true,
  );
};

export {
  logOnClickForcedSignupBNPL,
  logOnClickOptionalGuestBNPL,
  logWhenCheckingBnplEligibility,
  logWhenDisplayForcedSignupBNPL,
  logWhenDisplayOptionalGuestBNPL,
};
